import Immutable from 'seamless-immutable';
// ---- external imports ----

const INITIAL_YEAR = new Date().getFullYear();

const INITIAL_STATE = Immutable({
	statementsByQuarterNum: {},
	systemStatementsByQuarterNum: {},
	openingInventoryByQuarterNum: {},
	isSubmittedByQuarterNum: {},
	isFinancialRatiosSubmittedForLastQuarter: false,
	isFinancialStatementsAutomatedByQuarter: {},
	isFinancialRatiosAutomatedByQuarter: {},
	canSubmitFinancialStatements: true,
	accountReceivables: {},
	lostInventoryByQuarterNum: {},
	contributedCapital: null,
	hasAttemptedToSubmitFinancialStatements: false,
	hasAttemptedToSubmitFinancialRatios: false,
	displayedStatement: 'incomeStatement',
	isFinancialRatiosCardOpen: false,
	errorConfiguration: { statement: '', message: '', fieldToFix: ''},
	financialRatiosErrorField: '',
	distributedProfits: {},
	currentRetainedEarnings: 0,
	openingRetainedEarningsByMonth: { [INITIAL_YEAR]: { 1: 0}},
	isLoaded: false
});


export default INITIAL_STATE;
